module.exports = __webpack_public_path__ + "static/media/icon-youtube.95684b14.jpg";